var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMessages = function SvgMessages(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    accessibilityRole: "image"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.231 12.36V16.023C15.231 16.347 15.195 16.653 15.114 16.932C14.781 18.255 13.683 19.083 12.171 19.083H9.723L7.005 20.892C6.6 21.171 6.06 20.874 6.06 20.388V19.083C5.142 19.083 4.377 18.777 3.846 18.246C3.306 17.706 3 16.941 3 16.023V12.36C3 10.65 4.062 9.471 5.7 9.318C5.817 9.309 5.934 9.3 6.06 9.3H12.171C14.007 9.3 15.231 10.524 15.231 12.36Z",
    fill: "#037DD6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.175 15.24C18.318 15.24 19.281 14.862 19.947 14.187C20.622 13.521 21 12.558 21 11.415V6.825C21 4.71 19.29 3 17.175 3H9.525C7.41 3 5.7 4.71 5.7 6.825V7.5C5.7 7.752 5.898 7.95 6.15 7.95H12.171C14.61 7.95 16.581 9.921 16.581 12.36V14.79C16.581 15.042 16.779 15.24 17.031 15.24H17.175Z",
    fill: "#037DD6"
  })));
};
export default SvgMessages;